import {Component, OnInit, ViewChild} from '@angular/core';
import {PDFSource, PdfViewerComponent} from 'ng2-pdf-viewer';
import {BsModalRef} from "ngx-bootstrap/modal";
import {FileService} from "src/app/core/services/file.service";
import {MIME_TYPE} from "src/app/core/common/constant";
import * as FileSaver from 'file-saver';
import {TranslateService} from "@ngx-translate/core";
import {ToastrMessageService} from "src/app/core/services/toastr.message.service";

@Component({
  selector: 'app-contract-view',
  templateUrl: './contract-view.component.html',
  styleUrls: ['./contract-view.component.scss']
})
export class ContractViewComponent implements OnInit {
  @ViewChild(PdfViewerComponent) private pdfComponent: PdfViewerComponent;

  pdfSrc: string | PDFSource | ArrayBuffer;
  page = 1;
  zoom = 1;
  totalPages: number;
  isLoaded: boolean = false;
  blob: Blob;
  fileName: string = "";

  constructor(private bsModalRef: BsModalRef,
              private translate: TranslateService,
              public toastrMessage: ToastrMessageService,
              private fileService: FileService) {
  }

  ngOnInit() {
    this.pdfSrc = URL.createObjectURL(this.blob);
  }

  incrementPage(amount: number) {
    this.page += amount;
  }

  incrementZoom(amount: number) {
    this.zoom += amount;
  }

  afterLoadComplete(pdfData: any) {
    this.totalPages = pdfData.numPages;
    this.isLoaded = true;
  }

  nextPage() {
    this.page++;
  }

  prevPage() {
    this.page--;
  }

  closeModal(){
    this.bsModalRef.hide();
  }

  downloadFile() {
    FileSaver.saveAs(this.blob, this.fileName);
  }
}
